export default {
  zh: {
    'nav.home': 'DK 质押首页',
    'nav.lang': '切换语言',
    'nav.menu': '页面导航',
    'nav.invite': '邀请流程',
    'nav.stake': '质押数据',
    'nav.reward': '收益领取',
    'nav.team': '三代团队',
    'nav.trust': '规则与合约',
    'nav.connect': '连接钱包',
    'wallet.current': '当前钱包',
    'wallet.balance': '钱包余额',
    'wallet.dk': 'DK 余额',
    'wallet.copy': '复制地址',
    'wallet.address': '钱包地址',
    'wallet.disconnect': '断开钱包',
    'wallet.disconnected': '钱包已断开',
    'hero.title': '通缩为王',
    'hero.subtitle': '邀请与质押中心',
    'hero.tagline': '链上邀请 · 三代业绩 · 出局额度',
    'steps.title': '邀请流程',
    'steps.hint': '关系由 DK 转账写入代币合约，绑定后不可修改',
    'steps.oneTitle': '转入 0.2 DK',
    'steps.oneDesc': '向好友钱包转入 0.2 DK，发起邀请',
    'steps.twoTitle': '回转 0.1 DK',
    'steps.twoDesc': '好友向你回转 0.1 DK，链上永久绑定',
    'invite.title': '我的邀请',
    'invite.desc': '邀请只通过 DK 转账完成。输入对方地址，发出 0.2 DK 或回转 0.1 DK。',
    'invite.bound': '已绑定邀请人',
    'invite.qualify': '邀请资格',
    'invite.qualifyOn': '已具备',
    'invite.qualifyOff': '未具备',
    'invite.qualifyHint': '需先完成 0.1 DK 绑定，才能向好友发起 0.2 DK 邀请',
    'invite.confirm': '回转 0.1 DK 绑定',
    'invite.confirming': '绑定确认中…',
    'invite.friend': '好友钱包地址',
    'invite.send': '转入 0.2 DK 邀请',
    'invite.sending': '邀请转账确认中…',
    'invite.sent': '0.2 DK 已转出，等待对方回转 0.1 DK',
    'invite.needWallet': '连接钱包后可发起邀请或完成绑定',
    'invite.boundOk': '推荐关系绑定成功',
    'stake.title': '我的质押',
    'stake.sync': '链上同步',
    'stake.deposit': '累计质押',
    'stake.power': '质押算力',
    'stake.quota': '出局额度',
    'stake.lastStaticClaim': '静态收益最近领取',
    'stake.directs': '有效直推',
    'stake.people': ' 人',
    'stake.levels': '已解锁 {count} 层',
    'stake.empty': '连接钱包后读取质押与出局额度',
    'stake.note': '出局额度为质押算力的 2 倍，静态、加权与级差收益会扣减额度；额度归零后仓位退出。',
    'reward.title': '可领收益',
    'reward.static': '静态收益',
    'reward.global': '全网加权',
    'reward.nft': 'NFT 分红',
    'reward.total': '合计',
    'reward.claim': '领取收益',
    'reward.claiming': '领取中…',
    'reward.connect': '连接钱包',
    'reward.empty': '暂无',
    'reward.ok': '领取已提交，等待区块确认',
    'reward.note': '静态收益领取发 DK；全网加权与 NFT 分红领取发 BNB。静态与加权受出局额度上限约束。',
    'team.title': '三代团队',
    'team.chip': '共 {count} 人',
    'team.gen1': '一代',
    'team.gen2': '二代',
    'team.gen3': '三代',
    'team.perf': '本代业绩',
    'team.allPerf': '三代合计',
    'team.wholePerf': '全团队业绩',
    'team.connectTitle': '连接钱包查看三代团队',
    'team.connectHint': '绑定成功的下三级地址及其质押业绩将显示在这里',
    'team.loading': '正在读取链上推荐关系…',
    'team.emptyTitle': '这一代还没有成员',
    'team.emptyHint': '完成 0.2 / 0.1 DK 绑定后，下三级会出现在对应列表',
    'team.indexMiss': '当前节点未能扫出历史绑定事件。三代列表可能需要后续索引服务。',
    'team.memberPerf': '个人业绩',
    'trust.title': '规则与链上信任',
    'trust.ruleTitle': '邀请绑定后，质押收益按层级结算',
    'trust.ruleDesc': '直推每多 1 人解锁 2 层，最多 30 层。静态、加权与级差都会消耗出局额度。',
    'trust.network': '网络',
    'trust.audit': '合约源码',
    'trust.viewCode': '查看源码',
    'trust.token': '邀请关系',
    'trust.tokenValue': 'DK 转账绑定',
    'trust.rule': '执行规则',
    'trust.ruleValue': '合约不可篡改',
    'trust.copy': '复制',
    'trust.stake': '质押合约',
    'trust.dk': 'DK 代币',
    'trust.viewContract': '在区块浏览器查看合约',
    'footer.risk': '数字资产具有风险，请在充分了解规则后参与链上交互',
    'faq.q1': '如何完成邀请绑定？',
    'faq.a1': '你向好友转入 0.2 DK 发起邀请，好友再向你回转 0.1 DK。两次转账都成功后，推荐关系写入 DK 代币合约，之后不能修改。',
    'faq.q2': '出局额度怎么算？',
    'faq.a2': '每次质押按当时 BNB 折合 U 记入算力，出局额度为算力的 2 倍。领取静态、加权以及获得级差奖励时会扣减额度，额度归零即出局。',
    'faq.q3': '收益如何领取？',
    'faq.a3': '静态与 NFT 分红领取发 BNB，全网加权领取发 DK。各项单独领取，页面数量就是对应到账币种。',
    'faq.q4': '三代列表统计什么？',
    'faq.a4': '列表展示通过你（以及二代、三代）绑定成功的地址，以及每人在质押合约中的累计质押业绩。人数很多时，后续可能需要索引服务加速。',
    'copy.action': '复制',
    'copy.done': '已复制',
    'copy.manual': '长按复制',
    'copy.copied': '{label}已复制',
    'copy.missing': '{label}尚未配置',
    'copy.fail': '自动复制失败，请长按内容复制',
    'time.justNow': '刚刚',
    'common.pending': '待配置',
    'common.incomplete': '操作未完成',
    'lang.zh': '中文',
    'lang.en': 'English',
    'error.invalidAddress': '请输入有效的钱包地址',
    'error.selfReferrer': '不能邀请或绑定自己',
    'error.needWeb3': '请在支持 Web3 的钱包浏览器中打开',
    'error.noAccount': '未获取到钱包账户',
    'error.wrongNetwork': '请切换到正确网络（Chain ID {chainId}）',
    'error.reconnect': '请重新连接钱包',
    'error.confirmReferrer': '请先确认邀请人地址',
    'error.noToken': 'DK 代币地址尚未配置',
    'error.noStake': '质押合约地址尚未配置',
    'error.alreadyBound': '该地址已经绑定邀请人',
    'error.waitInvite': '尚未收到对方的 0.2 DK 邀请',
    'error.noReward': '当前没有可领取的收益',
    'error.nftNotRegistered': '当前地址未登记 NFT 分红',
    'error.insufficient': 'BNB 余额不足',
    'error.insufficientDk': 'DK 余额不足',
    'error.rejected': '已取消交易',
    'error.relationCycle': '该绑定会形成循环推荐',
    'error.txFailed': '交易未能完成，请稍后重试',
    'doc.title': 'DK 质押 · 通缩为王',
    'doc.description': 'DK 通缩王邀请流程、三代业绩与质押收益中心',
  },
  en: {
    'nav.home': 'DK Stake Home',
    'nav.lang': 'Language',
    'nav.menu': 'Menu',
    'nav.invite': 'Invite',
    'nav.stake': 'Stake',
    'nav.reward': 'Rewards',
    'nav.team': '3-Gen Team',
    'nav.trust': 'Rules & Contract',
    'nav.connect': 'Connect Wallet',
    'wallet.current': 'Current Wallet',
    'wallet.balance': 'Balance',
    'wallet.dk': 'DK Balance',
    'wallet.copy': 'Copy Address',
    'wallet.address': 'Wallet address',
    'wallet.disconnect': 'Disconnect',
    'wallet.disconnected': 'Wallet disconnected',
    'hero.title': 'Deflation King',
    'hero.subtitle': 'Invite & Stake Hub',
    'hero.tagline': 'On-chain invite · 3-gen stats · Exit quota',
    'steps.title': 'Invite Steps',
    'steps.hint': 'Binding is written by DK transfers and cannot be changed',
    'steps.oneTitle': 'Send 0.2 DK',
    'steps.oneDesc': 'Transfer 0.2 DK to your friend to start the invite',
    'steps.twoTitle': 'Return 0.1 DK',
    'steps.twoDesc': 'They send 0.1 DK back to lock the referral on-chain',
    'invite.title': 'My Invite',
    'invite.desc': 'Invites are DK transfers only. Enter an address, then send 0.2 DK or return 0.1 DK.',
    'invite.bound': 'Bound referrer',
    'invite.qualify': 'Invite eligibility',
    'invite.qualifyOn': 'Available',
    'invite.qualifyOff': 'Locked',
    'invite.qualifyHint': 'Bind with 0.1 DK first before you can invite friends with 0.2 DK',
    'invite.confirm': 'Return 0.1 DK to bind',
    'invite.confirming': 'Binding…',
    'invite.friend': 'Friend wallet address',
    'invite.send': 'Send 0.2 DK invite',
    'invite.sending': 'Sending invite…',
    'invite.sent': '0.2 DK sent. Waiting for 0.1 DK back',
    'invite.needWallet': 'Connect a wallet to invite or complete binding',
    'invite.boundOk': 'Referral bound successfully',
    'stake.title': 'My Stake',
    'stake.sync': 'On-chain Sync',
    'stake.deposit': 'Total Staked',
    'stake.power': 'Stake Power',
    'stake.quota': 'Exit Quota',
    'stake.lastStaticClaim': 'Last Static Claim',
    'stake.directs': 'Active Directs',
    'stake.people': '',
    'stake.levels': '{count} levels unlocked',
    'stake.empty': 'Connect a wallet to load stake and exit quota',
    'stake.note': 'Exit quota is 2x stake power. Static, global, and level rewards consume it. Quota at zero exits the position.',
    'reward.title': 'Claimable Rewards',
    'reward.static': 'Static',
    'reward.global': 'Global',
    'reward.nft': 'NFT Dividend',
    'reward.total': 'Total',
    'reward.claim': 'Claim',
    'reward.claiming': 'Claiming…',
    'reward.connect': 'Connect',
    'reward.empty': 'None',
    'reward.ok': 'Claim submitted. Waiting for confirmation',
    'reward.note': 'Static claims pay DK. Global and NFT claims pay BNB. Static and global are capped by exit quota.',
    'team.title': '3-Gen Team',
    'team.chip': '{count} total',
    'team.gen1': 'Gen 1',
    'team.gen2': 'Gen 2',
    'team.gen3': 'Gen 3',
    'team.perf': 'This gen',
    'team.allPerf': '3-gen total',
    'team.wholePerf': 'All-team performance',
    'team.connectTitle': 'Connect wallet to view your 3-gen team',
    'team.connectHint': 'Bound downline addresses and their stake performance show here',
    'team.loading': 'Reading on-chain referrals…',
    'team.emptyTitle': 'No members in this generation yet',
    'team.emptyHint': 'After 0.2 / 0.1 DK binding, the next three generations appear here',
    'team.indexMiss': 'This RPC could not scan historical bind events. A later indexer may be needed.',
    'team.memberPerf': 'Own performance',
    'trust.title': 'Rules & Trust',
    'trust.ruleTitle': 'After binding, stake rewards settle by level',
    'trust.ruleDesc': 'Each active direct unlocks 2 levels, up to 30. Static, global, and level rewards consume exit quota.',
    'trust.network': 'Network',
    'trust.audit': 'Source',
    'trust.viewCode': 'View Source',
    'trust.token': 'Referral',
    'trust.tokenValue': 'DK transfer bind',
    'trust.rule': 'Execution',
    'trust.ruleValue': 'Immutable Contract',
    'trust.copy': 'Copy',
    'trust.stake': 'Stake contract',
    'trust.dk': 'DK token',
    'trust.viewContract': 'View contract on explorer',
    'footer.risk': 'Digital assets involve risk. Participate only after understanding the rules.',
    'faq.q1': 'How do I bind a referral?',
    'faq.a1': 'Send 0.2 DK to your friend to invite. They send 0.1 DK back. After both transfers, the referral is stored on the DK token and cannot be changed.',
    'faq.q2': 'How is exit quota calculated?',
    'faq.a2': 'Each deposit adds U power from the BNB price. Exit quota is 2x that power. Claims and level rewards consume quota. Quota at zero exits the position.',
    'faq.q3': 'How do I claim rewards?',
    'faq.a3': 'Static and NFT claims pay BNB. Global claims pay DK. Each type has its own claim button showing the asset you will receive.',
    'faq.q4': 'What does the 3-gen list show?',
    'faq.a4': 'It lists addresses bound under you (and gens 2-3) plus each address\'s own staked performance. Large teams may later need an indexer.',
    'copy.action': 'Copy',
    'copy.done': 'Copied',
    'copy.manual': 'Long-press',
    'copy.copied': '{label} copied',
    'copy.missing': '{label} not configured',
    'copy.fail': 'Auto-copy failed. Long-press to copy',
    'time.justNow': 'just now',
    'common.pending': 'Pending',
    'common.incomplete': 'Action incomplete',
    'lang.zh': '中文',
    'lang.en': 'English',
    'error.invalidAddress': 'Enter a valid wallet address',
    'error.selfReferrer': 'You cannot invite or bind yourself',
    'error.needWeb3': 'Open this page in a Web3 wallet browser',
    'error.noAccount': 'No wallet account found',
    'error.wrongNetwork': 'Switch to the correct network (Chain ID {chainId})',
    'error.reconnect': 'Please reconnect your wallet',
    'error.confirmReferrer': 'Confirm the referrer address first',
    'error.noToken': 'DK token address is not configured',
    'error.noStake': 'Stake contract address is not configured',
    'error.alreadyBound': 'This address already has a referrer',
    'error.waitInvite': 'The 0.2 DK invite has not arrived yet',
    'error.noReward': 'No rewards to claim',
    'error.nftNotRegistered': 'This address is not registered for NFT dividends',
    'error.insufficient': 'Not enough BNB',
    'error.insufficientDk': 'Not enough DK',
    'error.rejected': 'Transaction cancelled',
    'error.relationCycle': 'This bind would create a referral cycle',
    'error.txFailed': 'Transaction failed. Please try again',
    'doc.title': 'DK Stake · Deflation King',
    'doc.description': 'DK Deflation King invite flow, 3-gen performance, and stake rewards',
  },
}
